import people1 from '../../assest/ahbaab/mission-accomplished.png'





const AboutusData = [
    {
        id: 1,
        heading: "Our Story",
        textdetail: "Our mission is to deliver reliable cleanroom solutions that ensure sterile, contaminant-free environments for manufacturing and research.",
        // linktag:"Seehot",
        imgSrc: people1,
    },
    {
        id: 2,
        heading: "Our Mission",
        textdetail: "To be the global leader in cleanroom technology and supplies, delivering cutting edge products and unparalleled customer service.",
        // linktag:"Checkomains",
        imgSrc: people1,
    },
    {
        id: 3,
        heading: "Core Value",
        textdetail: "We prioritize quality, innovation, customer commitment, and integrity to deliver top-tier cleanroom solutions with honesty and excellence.",
        // linktag:'Browsemains',
        imgSrc: people1,
    },
];
export default AboutusData